import { useContext } from "react";
import { useHistory } from "react-router-dom";
import { Button } from "antd";

import DocumentationContext from "../store/documentation-context";

import Card from "../components/ui/card";
import Content from "../components/ui/content";
import Header from "../components/ui/header";
import Footer from "../components/ui/footer";
import Stepper from "../components/ui/stepper";
import FileList from "../components/files/file-list";

const FilesPage = () => {
  const history = useHistory();

  const documentationCtx = useContext(DocumentationContext);

  const onBack = () => {
    history.push("/acta");
  };

  const onNext = async () => {
    history.push("/contact");
  };

  return (
    <Card>
      <Header />
      <Content>
        <Stepper />
        <FileList />
      </Content>
      <Footer>
        <Button type="secondary" onClick={onBack}>
          Anterior
        </Button>
        <Button
          type="primary"
          onClick={onNext}
          disabled={
            documentationCtx.archivos.filter((x) => !x.exceeded).length === 0
          }
        >
          Siguiente
        </Button>
      </Footer>
    </Card>
  );
};

export default FilesPage;
